var MDB = window.MDB || {};;
MDB.IoFormat = MDB.IoFormat || {};
MDB.IoFormat.Edit = MDB.IoFormat.Edit || {};

(function($) {

    var _config;

    $.extend(MDB.IoFormat.Edit, {
        boot: function(config) {
            _config = config;

            var addItem = $('#add-ioitem'),
                hashGenerator = $('.hash-generator'),
                modal = $('#edit-item-modal');

            var form = hashGenerator.parents('form');

            hashGenerator.click(function(e) {
                e.preventDefault();
                MDB.promptWithIcon(
                    MDB.loadResourceString('GenerateHashItems_Prompt_Title'),
                    MDB.loadResourceString('GenerateHashItems_Prompt_Body'),
                    "fa fa-exclamation text-warning",
                    function(ok) {
                        if (ok) {
                            form.submit();
                        }
                    }
                );
            });

            addItem.click(function (e) {
                e.preventDefault();
                MDB.IoFormat.Edit.editIoItem(config.ioItemCreateUrl);
            });

            //Empty modal when we close it. Just to make sure we don't get weird results.
            modal.on('hidden.bs.modal', function () {
                modal.find('.modal-body').empty();
            });
        },
        deleteIoItem: function(button, url) {
            var me = $(button);

            var ioInfo = me.next().text().split('-'),
                type = ioInfo.length > 0 ? ioInfo[0].trim('') : 'null',
                name = ioInfo.length > 0 ? ioInfo[1].trim('') : 'null';

            //Like.. Are you really sure?
            MDB.promptWithIcon(
                MDB.loadResourceString('IoItem_Delete_Prompt_Title'), 
                sprintf(MDB.loadResourceString('IoItem_Delete_Prompt_Body'), name, type), 
                'fa fa-trash-o text-danger',
                
                //Well alright then.
                function(ok){
                    if (ok) {
                        MDB.sendAjaxRequest(url, null, 'POST').done(function (response) {
                            if(response.value != null) {
                                MDB.Notify.bootstrapSuccess(MDB.loadResourceString('IoItem_Delete_Success_Notification_Text'));
                                me.parents('[data-type="io-item"]').first().remove();
                            } else {
                                MDB.Notify.bootstrapSuccess(MDB.loadResourceString('IoItem_Delete_Error_Notification_Text'));
                            }
                        });
                    }
                });
        },
        editIoItem: function (url) {

            //Get our modal.
            var modal = $('#edit-item-modal'),
                body = modal.find('.modal-body'),
                title = modal.find('.modal-title');

            //Load the io item partial into the modal.
            body.load(url, function() {
                
                var itemId = $('#ItemId'),
                    dropdown = $('#InternalTable'),
                    isNew = isEmpty(itemId.val()),  //If the itemId in the parial is null, means this is a new item.
                    submitbutton = $('#save-item'),
                    form = submitbutton.parents('form').first();

                //Set title based on new item or not.
                title.html(isNew ? 
                    '<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('IOItem_Create_Title') : 
                    '<i class="fa fa-pencil text-warning"></i> ' + MDB.loadResourceString('IOItem_Edit_Title'));

                //We need to get the attributes of the selected table and fill the attributeId dropdown.
                dropdown.change(function (e) {
                    getEntityAttributes(dropdown.val(), _config.getAttributesUrl);
                });

                //Fire the change event to force attributes to update if this is an edit.
                if(!isNew) {
                    dropdown.change();
                }

                //init event handlers for modifiers and validators.
                initModifiersAndValidators(body);

                //show the modal.
                modal.modal('show');
                
                //Save event, edit or create respectively.
                submitbutton.click(function (e) {
                    e.preventDefault();

                    if(isNew) {
                        createItem(form.serialize(), url);
                    } else {
                        editItem(form.serialize(), url, itemId.val());
                    }
                });
            });

            //Update IO Item. Response is either an array of errors or a partial with the IO Item.
            function editItem(model, url, itemId) {
                $.post(url, model).done(function (response) {
                    if(response.errors != null) {
                        MDB.Notify.bootstrapDanger(response.errors.join('<br />'));
                        return;
                    }

                    MDB.killOpenModals();

                    var form = $('#generate-hash'),
                        item = form.find('input[value="'+ itemId +'"]').parent(),
                        newItem = $(response);

                    newItem.insertAfter(item);
                    item.remove();

                    MDB.Notify.bootstrapSuccess(MDB.loadResourceString('IOItem_Edit_Success_Text'));
                });
            }

            //Create IO Item. Response is either an array of errors or a partial with the IO Item.
            function createItem(model, url) {
                $.post(url, model).done(function (response) {
                    if(response.errors != null) {
                        MDB.Notify.bootstrapDanger(response.errors.join('<br />'));
                        return;
                    }

                    MDB.killOpenModals();

                    $('#generate-hash').append(response);
                    MDB.Notify.bootstrapSuccess(MDB.loadResourceString('IOItem_Create_Success_Text'));
                });
            }

            function initModifiersAndValidators(element) {

                var addModifier = element.find('#add-modifier'),
                    addValidator = element.find('#add-validator');

                element.find('[data-action="remove-modifier"]').click(function() {
                    $(this).parents('.data-modifier').remove();
                });

                element.find('[data-action="remove-validator"]').click(function() {
                    $(this).parents('.data-validator').remove();
                });

                addModifier.click(function (e) {
                    e.preventDefault();
                    addDataModifier();
                });

                addValidator.click(function (e) {
                    e.preventDefault();
                    addDataValidator();
                });
            }

            function addDataModifier() {
                var container = $('#data-modifiers');
                container.append('<div class="col-md-12 data-modifier"></div>');
                var modifier = container.children('.data-modifier').last();

                modifier.load(_config.ioItemAddModifierUrl, function() {
                    var deleteBtn = modifier.find('.delete');

                    deleteBtn.click(function() {
                        $(this).parents('.data-modifier').remove();
                    });
                });
            }

            function addDataValidator() {
                var container = $('#data-validators');
                container.append('<div class=" col-md-12 data-validator"></div>');
                var validator = container.children('.data-validator').last();
                
                validator.load(_config.ioItemAddValidatorUrl, function() {
                    var deleteBtn = validator.find('.delete');

                    deleteBtn.click(function() {
                        $(this).parents('.data-validator').remove();
                    });
                });
            }

            //Get Attributes for given entityId. EntityId is from the InternalTable dropdown.
            function getEntityAttributes(entityId, url) {
                var dropdown = $('#InternalAttributeId');

                if(isEmpty(entityId)) {
                    clearDropdown(dropdown);
                } else {
                    MDB.sendAjaxRequest(url, {entityId: entityId}).done(function (response) {
                        clearDropdown(dropdown);

                        if(response.value != null) {
                            response.value.forEach(function(item) {
                                dropdown.append($('<option></option>').val(item.Value).text(item.Text));
                            });

                            var currentAttribute = $('#CurrentAttributeId').val();

                            if(!isEmpty(currentAttribute)) {
                                $('#InternalAttributeId').val(currentAttribute);
                            }
                        }     
                    });
                }
            }

            function clearDropdown(dropdown) {
                dropdown.html('');
                dropdown.append($('<option></option>').val(null).text('--Select attribute--'));
            }

            //Function to check if object is empty, because javascript is silly.
            function isEmpty(obj) {
                for(var key in obj) {
                    if(obj.hasOwnProperty(key)) {
                        return false;
                    }
                }
                return true;
            }
        }
    });
})(jQuery)